import state from './state';
import mutations from './mutations';

export default {
    namespaced: true,
    state,
    mutations,
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/store/product/index.js